module.exports = __webpack_public_path__ + "6dd3f0fdef1567ec154e08cbc1905349.svg";